export const AI_CREDIT_ALLOWANCE_ALERT_THRESHOLDS = [50, 80, 100];
export const isAiCreditThresholdReached = (threshold, usedCredits, allowanceCredits) => usedCredits * 100 >= allowanceCredits * threshold;
/** True when no threshold can change, so the period's usage need not be summed. */
export const isAiCreditAllowanceAlertPlanSettled = (records, allowanceCredits) => AI_CREDIT_ALLOWANCE_ALERT_THRESHOLDS.every((threshold) => records.some((record) => record.thresholdPercent === threshold &&
    record.allowanceCredits === allowanceCredits));
export const planAiCreditAllowanceAlerts = ({ usedCredits, allowanceCredits, records, }) => AI_CREDIT_ALLOWANCE_ALERT_THRESHOLDS.reduce((plan, threshold) => {
    const isReached = isAiCreditThresholdReached(threshold, usedCredits, allowanceCredits);
    const record = records.find((r) => r.thresholdPercent === threshold);
    if (record === undefined) {
        return isReached
            ? { ...plan, reached: [...plan.reached, threshold] }
            : plan;
    }
    if (record.allowanceCredits === allowanceCredits)
        return plan;
    return isReached
        ? { ...plan, carriedOver: [...plan.carriedOver, threshold] }
        : { ...plan, rearmed: [...plan.rearmed, threshold] };
}, { reached: [], rearmed: [], carriedOver: [] });
export const getAiCreditAllowanceAlertMessage = (threshold) => `Reached ${threshold}% of your AI credit allowance`;
//# sourceMappingURL=allowanceAlerts.js.map